<template>
  <div>
		<search-group
		@search="findData"
		@clear="clearValue"
		:span="18"
		:btnOffset="9"
		:btnSpan="6"
		:inline="true"
		:multipleLines="false"
		>
			<Row class="mb16" :gutter="16">
				<Col span="5">
					<Select  v-model="searchData.projectFid" placeholder="请选择项目" >
						<Option value=''>请选择</Option>
						<Option v-for="(item,index) in projectList" :key="index" :value="item.value">{{item.text}}</Option>
					</Select>
				</Col>
				<Col span="5">
					<Select v-model="searchData.appointStatus"  placeholder="是否启用" >
						<Option value=''>请选择</Option>
						<Option v-for="(item,index) in status"  :key='index' :value="item.value">{{item.text}}</Option>
					</Select>
				</Col>
			</Row>
		</search-group>
		<table-list
      class="page-wrapper"
      style="padding-top:0"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
		</table-list>
	</div>
</template>

<script>
import SearchGroup from 'components/SearchGroup/index';
import TableList from 'components/TableList/index';
import { getProjects } from 'api/common'
import {list,updateAppointStatus} from 'api/performanceManager'

export default {
	components:{
		SearchGroup,
		TableList
	},
	data(){
		return{
			current:1,
			total:0,
			loading:false,
			limit:10,
			page:1,
			projectList:[],
			searchData:{
				projectFid:'',
				appointStatus:'',
			},
			status:[
				{
					text:'启用',
					value:1,
				},
				{
					text:'停用',
					value:0,
				}
			],
			columns:[
				{
					type: 'index',
					width: 60,
					align: 'center'
				},
				{
					title: ' '
				},
				{
          title:'项目名称',
          key: 'projectName',
          width: 200,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'状态',
          key: 'appointStatusName',
          width: 120,
          align: 'center'
        },
        {
          title: ' '
				},
				{
          title:'项目经理计件',
          key: 'businessPhone',
          width: 120,
					align: 'center',
					render:(h,params)=>{
						return [
							h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'managerReckonSwth/updateAppointStatus'
                    }
                  }
								],
								on:{
									click:()=>{
										let state = params.row['appointStatus'] === 1 ? '停用' : '启用';
                    this.$Modal.confirm({
                      title: state+'公式',
                      content: '<p>确认'+state+'该项目经理计件?</p>',
                      onOk: () =>{
                        let isUseParams = params.row['appointStatus'] === 1? 0 : 1;
                        const params1 = {
                          projectFid:params.row['projectFid'],
                          appointStatus: isUseParams
                        }
                        updateAppointStatus(params1)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success(state+'成功')
                            this.getTableList();
                          }
                        })
                        .catch( err => {
                          this.$Message.info( state+'失败')
                        })
                        .finally( ()=> {
                          this.isShow = false
                        })
                      }
                    })
									}
								}
							},params.row['appointStatus'] === 1 ? '停用' : '启用')
						]
					}
        },
        {
          title: ' '
        },
			],
			data:[],
			
		}
	},
	created(){
		this.getProjectsData();
		this.getTableList();
	},
	methods:{
		getProjectsData(){
      getProjects()
      .then(res => {
        this.projectList = res.data;
      })
		},
		findData(){
      this.page=1
      this.current=1
      this.getTableList();
    },
    getTableList(){
      let params= {
        ...this.searchData,
        page:this.page,
        limit:this.limit
			}
      list(params)
      .then( res => {
        this.data = res.data.rows
        this.total = res.data.total
      })
    },
    changPage(n){
      this.current = n;
      this.page = n;
      this.getTableList()
    },
		clearValue(){
			this.searchData = {
				projectFid:'',
				appointStatus: ''
			}
		},
	}
}
</script>

<style>

</style>
